import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    height: 100vh;
    justify-content: center;
    align-items: center;
    background: #f6f6f6f6;
    .isHidden{
        visibility: hidden;
    }
    > div {
        position: relative;
        display: flex;
        min-width: 300px;
        width: 530px;
        height: 570px;
        flex-direction: column;
        border-radius: 10px;
        padding: 2rem;
        background-color: #ffffff;
        p {
            margin: 0;
            font-size: 1.3rem;
            font-weight: bolder;
            color: #2f2e41b5;
        };
        > img {
            position: absolute;
            max-height: 300px;
            bottom: 5px;
            right: 55px;
        };
        .acMt{
            margin-top: 1.75rem;
        }
        > div:nth-child(2){
            display: flex;
            justify-content: center;
            gap: 3rem;
            .op1{
                background: #1D86FF;
                color: #fff;
                font-weight: bold;
            }
            .op2 {
                background: transparent;
                border: solid 1px #3f3d56;
                color: #3f3d56;
            }
            > button{
                outline: none;
                border: none;
                height: 2rem;
                padding: .2rem 2rem;
                border-radius: 4px;
                cursor: pointer;
                &:hover{
                    opacity: .6;
                }
                transition: opacity 0.2s;
            }
        }
    };
`;
